export default __webpack_public_path__ + "static/traffic-monitoring-67b6b096bc061eaf196dbc1e916044e6.png";